import React from 'react';

import Button from "components/CustomButtons/Button.jsx";

import withStyles from "@material-ui/core/styles/withStyles";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircularProgress } from "@material-ui/core";

import Api from '../../../api/Api.js';
import ReactSelect from '../../../components/Select/ReactSelect';
import UserImage from '../../../components/Image/UserImage';

import { connect } from 'react-redux';
import UserEndpoints from '../../../api/UserEndpoints';
import { SET_USER_LIST } from '../../../redux/types';
import { store } from '../../../redux/store';

const style = {
    infoText: {
        fontWeight: "300",
        margin: "10px 0 30px",
        textAlign: "center"
    },
    inputAdornmentIcon: {
        color: "#555"
    },
    inputAdornment: {
        position: "relative"
    }
};

class PickUserDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedUser: { label: 'None', value: '' },
            loading: true
        }
    }

    componentDidMount() {
        Api.get(UserEndpoints.list)
        .then(({ data }) => {
            store.dispatch({ type: SET_USER_LIST, payload: data })
            this.setState({ loading: false });
        })
        .catch((e) => console.error(e));
    }

    render() {
        const { classes } = this.props;
        return (
            <Dialog
                open={this.props.isOpen}
                onClose={this.props.close}
                fullWidth
                maxWidth="sm"
                aria-labelledby="form-dialog-title"
                PaperProps={{ style: { overflow: 'visible' } }}
            >
                <DialogTitle id="form-dialog-title">Pick User</DialogTitle>
                <DialogContent style={{ overflow: 'visible' }}>
                    <ReactSelect
                        options={
                            this.props.allUsers && this.props.allUsers.length > 0 ?
                                [{ label: 'None', value: '' }].concat(this.props.allUsers.filter(u => !this.props.exclude.some(x => x === u.id)).map(u => ({ label: u.name + (u.surname ? " " + u.surname : ''), avatar: <UserImage {...u} />, value: u.id })))
                                :
                                [{ label: 'None', value: '' }]
                        }
                        onChange={(value) => this.setState({ selectedUser: value })}
                        placeholder="Please Select a User..."
                        value={this.state.selectedUser}
                        isSearchable
                        isLoading={this.state.loading}
                        isDisabled={this.state.loading}
                    />
                </DialogContent>
                <DialogActions>
                    <Button style={{ marginRight: 'auto' }} round onClick={this.props.close} color="rose" simple>
                        Cancel
                    </Button>


                    {
                        this.state.loading ?
                            <CircularProgress color="secondary" style={{ marginBottom: 5, marginRight: 10 }} />
                            :
                            <Button
                                onClick={() => this.state.selectedUser.value && this.props.submit && this.props.submit(this.state.selectedUser.value)}
                                color="rose"
                                round
                            >
                                Continue
                                &nbsp;&nbsp;
                                <FontAwesomeIcon icon={faCheck} />
                            </Button>
                    }
                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = ({ allUsers }) => {
    return {
        allUsers: allUsers.list
    }
}

export default withStyles({ ...extendedFormsStyle, ...style })(connect(mapStateToProps)(PickUserDialog));